export function normalizeAccountOrdersResponse(results) {
    if (!Array.isArray(results)) {
        return [];
    }

    return results.map((account) => ({
        ...account,
        orders: Array.isArray(account?.orders) ? account.orders : [],
        gtts: Array.isArray(account?.gtts) ? account.gtts : [],
    }));
}

const TERMINAL_ORDER_STATUSES = new Set(['COMPLETE', 'CANCELLED', 'REJECTED', 'EXPIRED']);

export function orderSupportsCancellation(order) {
    if (!order) {
        return false;
    }

    const status = String(order.status || '').toUpperCase();
    if (!status || TERMINAL_ORDER_STATUSES.has(status)) {
        return false;
    }

    if (!order.orderId || !order.variety) {
        return false;
    }

    return (
        status.includes('OPEN') ||
        status.includes('TRIGGER') ||
        status.includes('PENDING')
    );
}

export function gttSupportsCancellation(gtt) {
    if (!gtt) {
        return false;
    }

    const status = String(gtt.status || '').toUpperCase();
    if (!status) {
        return false;
    }

    return status === 'ACTIVE';
}
